import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteUpdateShipTo,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateShipTo";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

addToChainAfter(chain, DispatchCompleteUpdateShipTo, props => {
    props.dispatch({
        type: "Pages/CheckoutShipping/SetIsShippingAddressUpdateRequired",
        isShippingAddressUpdateRequired: false,
    });
});
